import React from 'react';
import { Collapse, SvgIconProps } from '@mui/material';

import { Paper, Typography, CardContent, CardHeader, IconAvatar } from '@occc-app/design-system';

type LimitFormContentLayoutProps = {
  children?: React.ReactNode;
  title: string;
  description?: string;
  action: React.ReactNode;
  open: boolean;
  avatar?: React.ElementType<SvgIconProps>;
};

export const LimitFormContentLayout = ({
  title,
  description,
  action,
  open,
  children,
  avatar: Icon,
}: LimitFormContentLayoutProps) => {
  return (
    <Paper>
      <CardHeader
        title={<Typography variant='subtitle1'>{title}</Typography>}
        subheader={
          <Typography variant='body2' color='textSecondary'>
            {description}
          </Typography>
        }
        action={action}
        avatar={Icon ? <IconAvatar Icon={Icon} /> : null}
        sx={{ py: 2, px: 3 }}
      />
      <Collapse in={open} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>{children}</CardContent>
      </Collapse>
    </Paper>
  );
};
